<template>
  <a
    href='https://api.whatsapp.com/send/?phone=34685489604&text=Hola%2C+he+visitado+vuestra+web+y+tengo+alguna+duda+%C2%BFpod%C3%A9is+ayudarme%3F&app_absent=0'
    target='_blank'
    class='whatsapp-button'
    aria-label='Contactar por WhatsApp'
  >
    <img
      :src="require('@/assets/images/whatsapp-icon.svg')"
      alt='WhatsApp'
      width='49'
      height='49'
    >
  </a>
</template>

<script lang='js'>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'WhatsAppButton',
});
</script>

<style lang='sass' scoped>
.whatsapp-button
  @apply fixed bottom-5 right-5 z-50 transition-transform duration-300 hover:scale-110
  img
    @apply drop-shadow-lg
  &:hover
    @apply transform scale-110
</style>
